export enum RadarDetectionGroupType {
  'CLIENT' = 'CLIENT',
  'ENVIRONMENT' = 'ENVIRONMENT',
  'EXTERNAL_SERVICE' = 'EXTERNAL_SERVICE',
  'SERVICE' = 'SERVICE',
}
